import { useEffect, useState } from "react";
import { apiCallsPreventiveMaintenance } from "../api/calls/preventiveMaintenance";
import { convertDate } from "../Helpers/preventiveMaintenanceHelper";


export const useMaintenance = (filters, setModalOpen) => {
    const [dataForGraphs, setDataForGraphs] = useState([]);
    const [dataForTable, setDataForTable] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});

    const getDataForGraphs = async (filters) => {
        try {
            const result = await apiCallsPreventiveMaintenance.Actions.GetStatsDemo(filters);

            setDataForGraphs(result);
            
        } 
        catch (err){
            console.error(err);
        }
    }

    const getDataForTable = async () => {
        try {
          const result = await apiCallsPreventiveMaintenance.Actions.GetDataTable();
          const parsedResult = result.map((item) => ({
            ...item,
            RegistrationDate: convertDate(item.RegistrationDate),
            DamageDate: convertDate(item.DamageDate),
            ReceiptDate: convertDate(item.ReceiptDate),
            RestorationDate: convertDate(item.RestorationDate),
            DateCreated: convertDate(item.DateCreated),
          }));
      
          setDataForTable(parsedResult);
        } catch (err) {
          console.error(err);
        }
      };

    useEffect(() => {
        getDataForTable();
        getDataForGraphs(filters);
    }, [filters])

    const handleSearchClick = () => {
        getDataForGraphs(filters);
    }

    const handleRowClick = (row) => {
        setSelectedRow(row)
        setModalOpen(true);
      };
    
    const handleCloseModal = () => {
        setModalOpen(false);
    };


    return {dataForGraphs, dataForTable, handleSearchClick, handleRowClick, handleCloseModal, selectedRow};

}